import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import '@/utility/ElementUI'
import store from './global'
import "@/utility/rem"
import i18n from '@/i18n'
import '../src/iconfont/iconfont.css'
import '@/utility/globalCss.css'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
